import LineOrange from "../../../common/LineOrange/LineOrange";

export const CertificateBenefits = (src) => {
  return (
    <>
      <div
        style={{ minHeight: "", backgroundColor: "" }}
        className="d-flex justify-content-center align-items-center"
      >
        <div className="container">
          <div className="title d-flex flex-column">
            <h3 className="text-right mt-5">مزایای مرتبط با سهامداران</h3>
            <LineOrange />
          </div>
          <div
            className="d-flex  align-items-start justify-content-center mb-5 mt-5"
            style={{ minHeight: "" }}
          >
            <div className="row align-items-center w-100 ">
              <div className="col-12 col-lg-6">
                <ul className="text-right mt-3" style={{ width: "565px" }}>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    تعیین‌ قیمت‌ منصفانه‌ دارایی‌ها
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    کاهش‌ ریسک‌ سرمایه‌گذاري به‌ دلیل‌ ارتقاء شفافیت‌{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    نقدشوندگی‌ بالا به‌ دلیل‌ وجود بازار منسجم‌{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    برخورداری از معافیت‌هاي مالیاتی‌{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    انتخاب متنوع اوراق بهادار با ریسک‌ و بازده متفاوت و توزیع‌ و
                    انتقال ریسک‌{" "}
                  </li>
                  <li className="mb-2">
                    <img
                      src={"/asset/images/Path 80.png"}
                      className=""
                      alt=""
                    />
                    نظارت بر فعالیت‌ شرکت‌ها در قالب‌ قواعد، روشها و قوانین‌
                    بازار سرمایه‌{" "}
                  </li>
                </ul>
              </div>
              {/* <div className="col-12 col-lg-6">
                <div className="text-center">
                  <img
                    src={"/asset/images/01.png"}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
